import { useNavigate } from 'react-router-dom';
import loading from '/asset/loading.gif';
import AuthCard, {
  authButtonClass,
  authInputClass,
  authLabelClass,
} from '../components/AuthCard';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { forgotPasswordAsync, setEmail } from '../store/authSlice';

export default function PasswordSetRequest() {
  const navigate = useNavigate();
  const { email, status: auth_status } = useSelector(
    (state: RootState) => state.auth
  );
  const { routesPrefix } = useSelector((state: RootState) => state.setup);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const dispatch = useDispatch<AppDispatch>();

  return (
    <AuthCard
      title="Reset your password"
      subtitle="Enter the email address on your account and we'll send you a 6-digit code to reset your password."
      icon={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-[24px] h-[24px]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={1.8}
        >
          <rect x="4" y="11" width="16" height="10" rx="2" />
          <path strokeLinecap="round" d="M8 11V7a4 4 0 0 1 8 0v4" />
        </svg>
      }
    >
      <div>
        <label className={authLabelClass}>Email Address</label>
        <input
          className={authInputClass}
          placeholder="you@example.com"
          type="text"
          value={email}
          onChange={(e) => dispatch(setEmail(e.target.value))}
        />
        {!emailRegex.test(email) && (
          <p className="text-[12px] text-gray-400 mt-[6px] font-dmsans">
            Enter a valid Email Address
          </p>
        )}
      </div>

      {auth_status !== 'loading' ? (
        <button
          className={`${authButtonClass} mt-[28px] bg-[#1E6DB4] hover:bg-[#195d9a] active:bg-[#154f83] text-white cursor-pointer`}
          onClick={() => {
            dispatch(forgotPasswordAsync({ email })).then(() => {
              navigate(`${routesPrefix}setpassword`);
            });
          }}
        >
          Send Reset Code
        </button>
      ) : (
        <div className="flex justify-center items-center gap-2 h-[52px] mt-[28px]">
          <img src={loading} className="w-[32px] h-[20px] object-cover" />
          <span className="font-dmsans text-[13px] text-gray-500">
            Loading...
          </span>
        </div>
      )}

      <div className="mt-[24px] text-center font-dmsans text-[14px] text-gray-500">
        Remember your password?{' '}
        <span
          className="text-[#1E6DB4] cursor-pointer hover:underline font-medium"
          onClick={() => navigate(`${routesPrefix}auth`)}
        >
          Log in
        </span>
      </div>
    </AuthCard>
  );
}
